{
  "name": "@davi-ai/retorik-framework",
  "version": "3.2.6",
  "description": "Retorik Framework package",
  "author": "DAVI",
  "license": "MIT",
  "repository": "none",
  "main": "dist/index.js",
  "module": "dist/index.modern.js",
  "types": "dist/index.d.ts",
  "source": "src/index.tsx",
  "standalone": "standalone/index.js",
  "targets": {
    "standalone": {
      "context": "browser",
      "outputFormat": "esmodule",
      "distDir": "standalone"
    },
    "module": {
      "context": "browser",
      "outputFormat": "esmodule",
      "distDir": "dist"
    }
  },
  "engines": {
    "node": ">=10"
  },
  "scripts": {
    "build": "parcel build",
    "start": "parcel watch",
    "test": "jest --env=jsdom --reporters=jest-junit",
    "test-console": "jest --env=jsdom",
    "test-update-snapshots": "jest --env=jsdom --updateSnapshot",
    "test-coverage-console": "jest --env=jsdom --reporters=jest-junit --coverage",
    "test-coverage": "jest --env=jsdom --reporters=jest-junit --coverage --coverageReporters=cobertura",
    "report": "npx parcel build src/index.tsx --reporter @parcel/reporter-bundle-analyzer",
    "credentials": "vsts-npm-auth -config .npmrc"
  },
  "peerDependencies": {
    "react": "18.3.1",
    "react-dom": "18.3.1"
  },
  "devDependencies": {
    "@babel/core": "^7.19.1",
    "@babel/plugin-proposal-decorators": "^7.24.7",
    "@babel/plugin-proposal-private-property-in-object": "^7.21.11",
    "@babel/preset-env": "^7.25.4",
    "@babel/preset-react": "^7.24.7",
    "@babel/preset-typescript": "^7.24.7",
    "@babel/runtime": "^7.23.8",
    "@parcel/packager-ts": "^2.13.2",
    "@parcel/reporter-bundle-analyzer": "^2.13.2",
    "@parcel/reporter-sourcemap-visualiser": "^2.13.2",
    "@parcel/transformer-inline-string": "^2.13.2",
    "@parcel/transformer-typescript-types": "^2.13.2",
    "@parcel/validator-eslint": "^2.13.2",
    "@parcel/validator-typescript": "^2.13.2",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/jest-dom": "6.5.0",
    "@testing-library/react": "16.0.1",
    "@testing-library/react-hooks": "8.0.1",
    "@testing-library/user-event": "14.5.2",
    "@types/jest": "^27.5.1",
    "@types/leaflet": "^1.8.0",
    "@types/node": "^12.12.38",
    "@types/react": "18.3.12",
    "@types/react-dom": "18.3.1",
    "@types/testing-library__jest-dom": "^5.14.5",
    "@types/testing-library__react": "latest",
    "@typescript-eslint/eslint-plugin": "^8.19.0",
    "@typescript-eslint/parser": "^8.19.0",
    "autoprefixer": "^10.4.7",
    "babel-eslint": "^10.0.3",
    "babel-jest": "^29.7.0",
    "babel-loader": "^8.2.5",
    "buffer": "^5.7.1",
    "canvas": "^2.9.0",
    "cross-env": "^7.0.2",
    "crypto-browserify": "^3.12.0",
    "eslint": "^9.16.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-config-standard": "^17.1.0",
    "eslint-config-standard-react": "^13.0.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-prettier": "^5.2.1",
    "eslint-plugin-promise": "^7.2.1",
    "eslint-plugin-react": "^7.37.2",
    "https-browserify": "^1.0.0",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-junit": "16.0.0",
    "npm-run-all": "^4.1.5",
    "parcel": "^2.13.2",
    "postcss": "^8.4.14",
    "postcss-url": "^10.1.3",
    "prettier": "^2.0.4",
    "process": "^0.11.10",
    "punycode": "^1.4.1",
    "querystring-es3": "^0.2.1",
    "react": "^18",
    "react-docgen-typescript-plugin": "^1.0.5",
    "react-dom": "18.3.1",
    "react-test-renderer": "^18.3.1",
    "resize-observer-polyfill": "^1.5.1",
    "stream-browserify": "^3.0.0",
    "stream-http": "^3.2.0",
    "string_decoder": "^1.3.0",
    "tailwindcss": "^3.1.0",
    "typescript": "5.3.2",
    "url": "^0.11.0",
    "util": "^0.12.4"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "@davi-ai/body-engine-sprite": "3.0.0",
    "@davi-ai/react-bodyengine-three": "^1.0.8",
    "@davi-ai/retorik-weather": "2.0.0",
    "@davi-ai/speechmarkdown-davi-js": "2.0.1",
    "@davi-ai/web-speech-cognitive-services-davi": "2.1.0",
    "@lottiefiles/react-lottie-player": "^3.4.1",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.200.0",
    "@opentelemetry/instrumentation": "^0.200.0",
    "@opentelemetry/instrumentation-document-load": "^0.45.0",
    "@opentelemetry/instrumentation-fetch": "^0.200.0",
    "@opentelemetry/resources": "^2.0.0",
    "@opentelemetry/sdk-trace-web": "^2.0.0",
    "@opentelemetry/semantic-conventions": "^1.32.0",
    "@react-spring/types": "^9.7.3",
    "@react-spring/web": "^9.7.3",
    "@swc/helpers": "^0.5.0",
    "@types/geojson": "^7946.0.10",
    "@types/jsdom": "^16.2.14",
    "@use-gesture/react": "^10.2.15",
    "adaptivecards": "3.0.1",
    "botframework-directlinejs": "^0.15.5",
    "classnames": "^2.3.1",
    "detect-gpu": "^5.0.70",
    "leaflet": "^1.9.2",
    "markdown-it": "14.1.0",
    "pdfjs-dist": "3.11.174",
    "postcss-copy": "^7.1.0",
    "qrcode": "^1.5.1",
    "react-device-detect": "^2.2.3",
    "react-error-boundary": "^4.0.10",
    "react-leaflet": "^4.1.0",
    "react-pdf": "7.7.1",
    "react-shadow": "^20.5.0",
    "swiper": "^8.4.5",
    "zustand": "^5.0.3"
  },
  "overrides": {
    "@davi-ai/web-speech-cognitive-services-davi": "$@davi-ai/web-speech-cognitive-services-davi",
    "zustand": "$zustand"
  },
  "@parcel/resolver-default": {
    "packageExports": true
  }
}
